// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1TZ__","itemTitle":"ClientEmergencyInfo_itemTitle__1gwkt","itemText":"ClientEmergencyInfo_itemText__1V9Pm"};